export default __webpack_public_path__ + "static/media/avatar_14.adeb69fc.png";